class Dom {
	constructor(selector, where = document) {
		this.self = where.querySelector(selector);
		this.elems = where.querySelectorAll(selector);
	}
	each(callback) {
		this.elems.forEach((elem, index) => {
			return callback(elem, index);
		});
	}

	on(event, callback) {
		this.elems.forEach((elem, index) => {
			elem.addEventListener(event, (evt) => {
				return callback(elem, index, evt);
			});
		});
	}
}

window.addEventListener('click', (evt) => {
	const target = evt.target;

	if (target.classList.contains('cart-drawer__overlay')) {
		const cartDrawer = document.querySelector('cart-drawer');
		if (cartDrawer) cartDrawer.close();
	}
})

class CustomFilters {
	constructor(selector) {
		const load_elements = setInterval(() => {
			this.parents = new Dom(selector);

			if (this.parents.elems.length > 1) {
				this.init();

				clearInterval(load_elements);
			}
		}, 5);

		setTimeout(() => clearInterval(load_elements), 15000);
		this.filter_group_delegate_init();
		window.addEventListener('resize', this.topPosition);
	}

	init(open = null) {
		if (open) {
			this.parents.each((parent) => {
				const triggers = new Dom('.facets__heading', parent);

				triggers.each((trigger) => {
					if (trigger.classList.contains('close')) {
						this.setFacetsHeadingState(trigger, true);
					}
				});
			});
		}

		this.parents.each((parent) => {
			const triggers = new Dom('.facets__heading', parent);

			if (triggers.self) {
				triggers.each((trigger) => {
					if (
						trigger.classList.contains('open') ||
						trigger.classList.contains('close') ||
						trigger.hasAttribute('aria-expanded')
					) {
						this.setFacetsHeadingState(trigger, trigger.classList.contains('open'));
					}

					if (trigger.dataset.facetsHeadingInitialized === 'true') return;

					trigger.dataset.facetsHeadingInitialized = 'true';
					trigger.addEventListener('click', () => {
						this.toggleFacetsHeading(trigger);
					});
					trigger.addEventListener('keydown', (event) => {
						if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

						event.preventDefault();
						this.toggleFacetsHeading(trigger);
					});
				});
			}
		});

		this.filter_group_state_sync();
		this.filter_option_keyboard_init();
		this.mobile_triggers();
	}

	setFacetsHeadingState(trigger, isOpen) {
		trigger.classList.toggle('open', isOpen);
		trigger.classList.toggle('close', !isOpen);
		trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
	}

	toggleFacetsHeading(trigger) {
		this.setFacetsHeadingState(trigger, trigger.classList.contains('close'));
		this.change_icon();
	}

	change_icon() {
		this.parents.each((parent) => {
			const details = new Dom('details.disclosure-has-popup', parent);
			const open = Array.from(details.elems).find((elem) => elem.hasAttribute('open'));
			const products_grid = document.querySelector('#product-grid');

			if (open) {
				products_grid.style.opacity = 0;
				products_grid.closest('.shopify-section').classList.add('show-filters');
				const heading = new Dom('.facets__heading')?.self;

				if (heading) {
					this.setFacetsHeadingState(heading, true);
				}

				setTimeout(() => {
					products_grid.style.opacity = 1;
				}, 20);
			}

		});
	}

	topPosition() {
		this.parents?.each((parent) => {
			const popup = new Dom('.parent-display', parent);

			if (popup.elems.length > 0) {
				const facets_container = new Dom('.facets-container');
				const top = facets_container.self.offsetHeight;

				popup.self.style.top = top + 1 + 'px';
				popup.self.style.height = document.querySelector('#ProductGridContainer').offsetHeight + 'px';
			}
		});
	}

	getFilterGroupFocusableElements(group) {
		const body = group.querySelector('.wrap_body');
		if (!body) return [];

		return Array.from(
			body.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'),
		).filter((element) => !element.matches('[disabled], [aria-disabled="true"]'));
	}

	setFilterGroupState(group, isOpen) {
		group.classList.toggle('open', isOpen);

		const trigger = group.querySelector('.wrap_header .filter_group_title');
		const body = group.querySelector('.wrap_body');

		if (trigger) {
			trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		}

		if (!body) return;

		body.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
		if ('inert' in body) {
			body.inert = !isOpen;
		}

		this.getFilterGroupFocusableElements(group).forEach((element) => {
			if (isOpen) {
				if ('filterOriginalTabindex' in element.dataset) {
					const originalTabindex = element.dataset.filterOriginalTabindex;

					if (originalTabindex) {
						element.setAttribute('tabindex', originalTabindex);
					} else {
						element.removeAttribute('tabindex');
					}

					delete element.dataset.filterOriginalTabindex;
				}
			} else {
				if (!('filterOriginalTabindex' in element.dataset)) {
					element.dataset.filterOriginalTabindex = element.getAttribute('tabindex') || '';
				}

				element.setAttribute('tabindex', '-1');
			}
		});

		if (!isOpen && body.contains(document.activeElement)) {
			trigger?.focus({ preventScroll: true });
		}
	}

	storeOpenFilterGroups(group) {
		const wrapper = group.closest('#FacetsWrapperMobile, #FacetsWrapperDesktop');
		const openTabs = Array.from(wrapper?.querySelectorAll('.facets-layout .filter_wrap') || []);
		const openTabsArray = openTabs.filter((tab) => tab.classList.contains('open')).map((tab) => tab.dataset.index);

		sessionStorage.setItem('tab-open', JSON.stringify(openTabsArray));
	}

	getStoredOpenTabs() {
		try {
			const openTabs = JSON.parse(sessionStorage.getItem('tab-open')) || [];
			return Array.isArray(openTabs) ? openTabs : [];
		} catch {
			return [];
		}
	}

	filter_group_state_sync() {
		this.parents.each((parent) => {
			const groups = new Dom('.filter_wrap', parent);

			groups.each((group) => {
				this.setFilterGroupState(group, group.classList.contains('open'));
			});
		});
	}

	// Delegated + capture-phase, bound from the constructor: survives the init
	// poller race, the refresh's innerHTML swaps, and bubble-phase stopPropagation.
	filter_group_delegate_init() {
		if (CustomFilters.filterGroupDelegateBound) return;
		CustomFilters.filterGroupDelegateBound = true;
		document.addEventListener(
			'click',
			(event) => {
				const target = event.target;
				if (!(target instanceof Element)) return;

				const trigger = target.closest('.wrap_header .filter_group_title');
				if (!trigger) return;
				const group = trigger.closest('.filter_wrap');
				if (!group) return;

				this.setFilterGroupState(group, !group.classList.contains('open'));
				this.storeOpenFilterGroups(group);
			},
			{ capture: true },
		);
	}

	filter_option_keyboard_init() {
		this.parents.each((parent) => {
			if (parent.dataset.filterOptionKeyboardInitialized === 'true') return;

			parent.dataset.filterOptionKeyboardInitialized = 'true';
			parent.addEventListener('keydown', (event) => {
				if (event.key !== 'Enter') return;

				const target = event.target;
				if (!(target instanceof Element)) return;
				if (!target.matches('.filter_wrap .wrap_body input[type="checkbox"]')) return;

				event.preventDefault();
				target.click();
			});
		});
	}

	mobile_triggers() {
		this.parents.each((parent) => {
			const mobile_trigger = new Dom('.mobile-facets__open-wrapper');
			mobile_trigger.on('click', () => {
				const mobile_facets_details = new Dom('.mobile-facets__details', parent);
				mobile_facets_details.elems[0]?.setAttribute('open', '');
			});
		});
	}

	read_open_tab() {
		this.parents.each((parent) => {
			const groups = new Dom('.facets__disclosure-vertical .filter_wrap', parent);
			const groups_mobile = new Dom('.mobile-facets__details .filter_wrap', parent);

			const openTabs = this.getStoredOpenTabs();
			const heading = new Dom('.facets__heading', parent);
			const isHeadingOpen = sessionStorage.getItem('facets-heading-open') === 'true';

			const selectTabs = (elements) => {
				elements.each((group) => {
					const shouldOpen = openTabs.some((tab) => +group.dataset.index === +tab);
					this.setFilterGroupState(group, shouldOpen);
				});
			};

			selectTabs(groups);
			selectTabs(groups_mobile);

			if (heading.self && isHeadingOpen) {
				this.setFacetsHeadingState(heading.self, true);
			} else if (heading.self) {
				this.setFacetsHeadingState(heading.self, false);
			}

		});
	}
}

if (!window.custom_filters) {
	window.custom_filters = new CustomFilters('facet-filters-form');
}
